import React from 'react';

const ImageSection = () => {
  return (
    <div style={{ 
      width: '100%', 
      margin: 0, 
      padding: 0,
      lineHeight: 0
    }}>
      <img
        src="/images/Full Size - newlyweds-at-a-wedding-of-sparklers-2026-01-07-05-54-23-utc.jpg"
        alt="Wedding"
        style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          objectFit: 'cover'
        }}
      />
    </div>
  );
};

export default ImageSection;
